export default "__VITE_ASSET__3d31528b__"